(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["history"]) return;
  try {
    
    $('.history .selectors').on('click', '.selector', function () {
        $('.history .selectors .selector.active').removeClass('active')
        $('.historyContent.active').removeClass('active')
        var id = $(this).addClass('active').attr('data-for')
        $('#history-' + id).addClass('active')
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-header"] && !window.DesignMode) return;
  try {
    
  $('#header').slick({slidesToShow: 1, slidesToScroll: 1, autoplay: true, autoplaySpeed: 5000, dots: true })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-mittag"] && !window.DesignMode) return;
  try {
    
$('.mtslider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
	dots: false,
	arrows: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('.mittagsAngebote .selectors').on('click', '.selector', function () {
    $('.mtslider').slick('slickGoTo', $(this).data('for') - 1, false)
  })

  $('.mtslider').on('afterChange', function (evt, slick, slide) {
    $('.mittagsAngebote .selectors .selector.active').removeClass('active')
    $('.mittagsAngebote .selectors .selector[data-for="' + (slide +1) + '"]').addClass('active')
  })

  } catch(e) { console.error(e); }
})();

})();
